import { IconNames } from '@app/shared/enums/icon-names';
import { PaginationQueryRequest } from '../pagination-query-request.model';
import { SanityColorCode } from '../sanity.model';

export interface BattlecardsOffering {
  id: string;
  name: string;
  freeText?: string;
  operator: BattlecardsOperator;
  isFreeDataPackage: boolean;
  monthlyPrice: number;
  services: BattlecardsService[];
  ageGroup: BattlecardsAgeCategory;
  recommendationBasis?: RecommendationBasis; // Only applies to internal offerings
}

export enum BattlecardsAgeCategory {
  Adult = 'adult',
  Young = 'young',
  Junior = 'junior',
}

export interface BattlecardsOperator {
  id: string;
  name: string;
  colorCode: SanityColorCode;
  link: string;
  maxAgeYoung?: number;
  maxAgeJunior?: number;
}

export interface BattlecardsService {
  name: string;
  category: BattlecardsServiceCategory;
}

export interface BattlecardsServiceCategory {
  id: string;
  name: string;
}

export interface BattlecardsOfferingResponse {
  currentPage: number;
  take: number;
  data: BattlecardsOffering[];
  totalRows: number;
}

export interface BattlecardsOfferingRequest extends PaginationQueryRequest {
  operators?: string[];
  ageCategories?: string[];
  serviceCategories?: string[];
}

export interface BattlecardsRecommendedOffering {
  sanityId: string;
  recommendationBackground: RecommendationBasis;
}

export interface RecommendationBasis {
  priceDifference: number;
  gbDifference?: number;
  recommendationReason?: RecommendationReason;
}

export enum RecommendationReason {
  SameOrLowerDataLowerPrice = 'SameOrLowerDataLowerPrice',
  MoreDataLowerPrice = 'MoreDataLowerPrice',
  MoreDataSamePrice = 'MoreDataSamePrice',
  MoreDataHigherPrice = 'MoreDataHigherPrice',
  UpgradeToFreeDataLowerPrice = 'UpgradeToFreeDataLowerPrice',
  UpgradeToFreeDataHigherPrice = 'UpgradeToFreeDataHigherPrice',
  UpgradeToFreeDataSamePrice = 'UpgradeToFreeDataSamePrice',
  Comparable = 'Comparable',
}

export enum InternalOfferingsVisibility {
  Hide,
  ShowAll,
  OnlyShowRecommended,
}

export interface BattlecardsRecommendedOfferingBackgroundData {
  mainText: string;
  subText: string;
  icon?: IconNames;
}
